<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A2Rljx/tc-custom/9781618683977.jpg?1704761550941" alt="This image is the cover for the book Carrier"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carrier
      </h1>
      <p class="bookDescription body article font2">
        <b>“Beautiful writing, good zombie action and a compelling cast of characters onboard a massive spaceship make <i>Carrier</i> a fun ride.” —Craig DiLouie, author of <i>Suffer The Children</i></b><br/><br/><i>With Earth’s resources on the verge of exhaustion and worldwide civil war imminent, we looked to the stars for answers. Beneath the surface of lifeless planets, we found all the resources we could ever consume . . .</i><br/><br/>Stellan Lund is chief security officer aboard the Atlas, a carrier. Life on a carrier is peaceful. As long as the Atlas’ crew does its job, the New Earth Council leaves them alone. The only risk is an occasional case of black madness, a mental-break condition thought to be caused by extended deep space travel. It’s a small risk to take for freedom.<br/><br/>But then Adelynn Skinner, an agent of the New Earth Council, boards and orders the Atlas to uncharted territory where a dying planet with unidentified material waits. It could be the key to ending New Earth’s civil war—or it could end civilization as they know it. They will break protocol and mine the planet before its red giant star consumes it, because some risks are worth taking.<br/><br/>Stellan isn’t about to let Skinner jeopardize the Atlas or its crew, but with mounting disturbances and rising concern over the black madness, Stellan struggles just to hold the ship together. When an accident exposes some of the crew to the alien material, reports of black madness escalate. But something about these cases is different—and it seems to be spreading…<br/><br/>Combining character-rich storytelling, dystopian themes, and suspense that builds into an avalanche, <i>Carrier</i> follows Stellan Lund as he discovers that he carries the fate of a world and sacrificing whatever remains of his soul may be necessary to survive. It’s an action-packed, horrifying contemplation of what it means to be heroic, and how the most beautiful human traits may lead to the destruction of all that we cherish.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Timothy Johnson
      </h2>
      
      <p class="authorDescription body article">Timothy Johnson is a speculative fiction author and editor living outside Washington, D.C., with his wife and his dog. His work includes the novels THE PILLARS OF DAWN and CARRIER as well as short fiction published in various professional and semi-professional markets. He has an English degree from Virginia Tech, where he won the fiction award for his graduating class. He is a member of the Horror Writers Association. Nothing frightens him more than the future, so he writes about it in hopes he is wrong.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Permuted Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c7f1173